import React, {useContext, useEffect, useState} from "react";
import { useHistory } from "react-router-dom";

import db from "../../services/query";
import {AuthContext} from "../../contexts/authContext";
import Img from "../common/Img";
import EmailIcon from "../../icons/email-icon";
import lbl from "../../data/Labels.json";
import PopUpList from "../common/PopUpList";
import {PopUpContext} from "../../contexts/popUpContext";

const UserProfilePopUp = () => {

    const {
        currentUser,
        logOut,
    } = useContext(AuthContext);
    const phoneNumber = currentUser?.phoneNumber;

    const [user, setUser] = useState([]);
    const {togglePopUp} = useContext(PopUpContext);
    const history = useHistory();

    useEffect(async () => {
        const ac = new AbortController();

        await db
            .getAll(`login`)
            .then((res) => setUser(res.data.data[0]));

        return () => ac.abort();
    }, [phoneNumber]);


    const handleLogOut = () => {
        if (typeof logOut === "function") logOut();
        else window.location.href = "/login";
    }

    const openMyProfile = () => {
        togglePopUp();
        history.push("/mis/my-profile");
    }

    return (
        <div className="pop-up-container">
            <div style={{width: "350px"}} className="pop-up-wrapper">

                <div className="pop-up-head">
                    <p>{lbl.UserInfo}</p>
                </div>

                <div className="pop-up-body">
                    <div style={{padding: "5px"}}>
                        <div className="user_details_area">
                            <div style={{height: "70px", width: "100%"}}>
                                <div className="user_profile_image">
                                    <Img src={user?.photo} border={true}/>
                                </div>
                                <div className="user_profile_details">
                                    <p>{user?.name}</p>
                                    <p>{user?.position}</p>
                                </div>
                            </div>

                            <div className="user_information_area">
                                <p>{user?.user_name} <i>
                                    <svg viewBox="0 0 9.347 9.346">
                                        <path
                                            d="M70.161,53.44a.526.526,0,0,0-.533,0l-.83.5a.52.52,0,0,1-.589-.035,13.218,13.218,0,0,1-1.184-1.032,13.482,13.482,0,0,1-1.032-1.183.52.52,0,0,1-.035-.589l.5-.832a.522.522,0,0,0,0-.533l-1.219-2.084a.527.527,0,0,0-.581-.245,1.726,1.726,0,0,0-.806.484c-.941.941-1.44,2.527,2.1,6.064s5.123,3.037,6.064,2.1a1.749,1.749,0,0,0,.486-.808.524.524,0,0,0-.245-.578Z"
                                            transform="translate(-63.16 -47.389)"></path>
                                    </svg>
                                </i></p>
                                <p>{user?.user_email} <i>
                                    <svg viewBox="0 0 9.347 9.348">
                                        <path
                                            d="M56.656,51.553c0,1.768-.858,2.862-2.256,2.862a1.308,1.308,0,0,1-1.392-.847H52.9a1.3,1.3,0,0,1-1.313.854c-1.169,0-1.943-.943-1.943-2.367,0-1.365.747-2.284,1.859-2.284a1.355,1.355,0,0,1,1.307.8h.108V49.9h1.29v2.851c0,.4.18.634.484.634.493,0,.808-.657.808-1.7a3.15,3.15,0,0,0-3.4-3.333,3.5,3.5,0,0,0-3.632,3.721c0,2.232,1.482,3.63,3.861,3.63a5.294,5.294,0,0,0,1.342-.157v1a6.018,6.018,0,0,1-1.465.167c-2.936,0-4.9-1.868-4.9-4.668a4.527,4.527,0,0,1,4.806-4.68C54.821,47.367,56.656,49.062,56.656,51.553Zm-5.535.539c0,.73.3,1.167.814,1.167s.831-.443.831-1.167-.321-1.167-.831-1.167S51.121,51.362,51.121,52.091Z"
                                            transform="translate(-47.309 -47.367)"></path>
                                    </svg>
                                </i></p>
                            </div>
                        </div>


                        <div className="user_signout_area">
                            <a onClick={openMyProfile}>{lbl.MyAccountProfile}</a>
                            <a className="logout-link" onClick={handleLogOut}>{lbl.Logout}</a>
                            <a className="cancel-link" onClick={togglePopUp}>{lbl.Cancel}</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfilePopUp;
